import { Injectable } from '@angular/core';
import { AngularFirestore, DocumentReference } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';
import { AngularFireStorage } from '@angular/fire/storage';
import { ErrorMonitoringService } from 'src/app/services/error-monitoring/error-monitoring.service';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  usersRef = 'userProfile';
  beneficiaryRef = 'users';


  constructor(
    private angularFirestore: AngularFirestore,
    private storage: AngularFireStorage,
    private errorMonitoringService: ErrorMonitoringService,
  ) { }

  // agrega el beneficiario
  addBeneficiary(beneficiary: any): Promise<DocumentReference> {
    return this.angularFirestore.collection<any>(this.beneficiaryRef).add(beneficiary);
  }

  // obtiene los beneficiarios del cliente
  getBeneficiaries(userId: string) {
    return this.angularFirestore.collection<any>(
      this.beneficiaryRef, ref =>
      ref.where('active', '==', true).where('client', '==', userId).orderBy('name', 'asc')
    ).snapshotChanges().pipe(
      map(beneficiaries => {
        return beneficiaries.map(beneficiary => {
          const data = beneficiary.payload.doc.data();
          const id = beneficiary.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

  updateField(user: string, data: any) {
    return this.angularFirestore.collection<any>(this.beneficiaryRef).doc(`${user}`).update({
      document: data
    });
  }

  updateBeneficiary(userId: string, beneficiary: any) {
    return this.angularFirestore.collection<any>(this.beneficiaryRef).doc<any>(userId).update(beneficiary);
  }

  uploadFile(user: string, file: any) {
    return new Promise((resolve, reject) => {
      let filePath;
      // Ruta en la que se almacena
      filePath = `user_documents/${user}/${file.name}`;
      // Almacena la imagen
      this.storage.upload(filePath, file).then(snapshot => {
        // Obtiene la url de descarga
        snapshot.ref.getDownloadURL().then((downloadURL) => {
          resolve(downloadURL);
        });
      }).catch(error => {
        this.errorMonitoringService.sendError(error, 'uploadFile');
        reject();
      });
    });
  }

}
